import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { classNames } from "helpers";
import { transformRoute } from "helpers/common";
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";
import { NotificationEntityType } from "services/api/notifications/types";
import { Routes as FleetRoutes } from "ui/modules/fleet/vehicles/navigation/routes";

const getEntityRoute = (
  entityType: number,
  entityId: string,
  parentEntityId?: string
): string | null => {
  switch (entityType) {
    case NotificationEntityType.VehicleRegistration:
    case NotificationEntityType.VehicleInsurance:
      return transformRoute(FleetRoutes.FleetVehicleDetailPageRouter, { id: entityId });
    case NotificationEntityType.FireExtinguisher:
      if (!parentEntityId) return null;
      return transformRoute(FleetRoutes.FleetVehicleFireExtinguisherSearchPageRouter,
        {
          id: parentEntityId,
          //fireextinguisherid: entityId,
        }
      );
    case NotificationEntityType.Offer:
      return transformRoute(FleetRoutes.FleetVehicleOfferSearchPageRouter, {
        id: parentEntityId,
        //fireextinguisherid: entityId,
      });
    case NotificationEntityType.Contract:
      return transformRoute(FleetRoutes.FleetVehicleContractSearchPageRouter,  {
        id: parentEntityId,
        //fireextinguisherid: entityId,
      });
    case NotificationEntityType.Invoice:
      return transformRoute(FleetRoutes.FleetVehicleInvoiceSearchPageRouter,  {
        id: parentEntityId,
        //fireextinguisherid: entityId,
      });
    default:
      return null;
  }
};

const NotificationEntityRowChild: React.FC<TableRowChildProps> = ({ index, row }) => {
  const navigate = useNavigate();
  const route = getEntityRoute(row.entityType, row.entityId, row.parentEntityId);

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (!route) return;
      e.stopPropagation();
      navigate(route);
    },
    [navigate, route]
  );

  return (
    <tr
      className={classNames(
        "hover:bg-slate-100",
        index % 2 === 0 ? "bg-white" : "bg-slate-50",
        route ? "cursor-pointer" : ""
      )}
      onClick={handleClick}
    >
      <td className="px-4 py-3 text-sm text-slate-600">
        <span className={route ? "text-sky-600 hover:underline" : ""}>
          {row.displayName}
        </span>
      </td>
    </tr>
  );
};

export default memo(NotificationEntityRowChild);
